import React from "react";
import { useIsMobile } from "../../hooks/is.mobile";
import { NavbarPC } from "./navbar.pc";
import { NavbarMobile } from "./navbar.mobile";

export const Navbar: React.FC = () => {
  const isMobile = useIsMobile();
  return <div> {isMobile ? <NavbarMobile /> : <NavbarPC />} </div>;
};
